// Tier-2 <Modal> with title/body/footer (FORT-182). Wraps AntD Modal; the
// open/onClose contract is ours.
//
// Footer resolution mirrors the two real usage shapes across the app:
//   * `footer` given  → render it verbatim (custom action row).
//   * `onOk` given    → AntD's default OK / Cancel footer (okText/cancelText/
//                        confirmLoading apply).
//   * neither         → no footer.
import React from 'react';
import { Modal as AntModal } from 'antd';
import type { CommonProps } from './types';

export interface ModalProps extends CommonProps {
  open: boolean;
  title?: React.ReactNode;
  footer?: React.ReactNode;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
  onOk?: () => void;
  onClose: () => void;
  confirmLoading?: boolean;
  width?: number | string;
  centered?: boolean;
  closable?: boolean;
  /** Close when the backdrop is clicked. Defaults to true. */
  maskClosable?: boolean;
  children: React.ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
  open,
  title,
  footer,
  okText,
  cancelText,
  onOk,
  onClose,
  confirmLoading,
  width,
  centered,
  closable,
  maskClosable = true,
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => {
  // undefined → AntD default OK/Cancel footer; null → no footer.
  const resolvedFooter = footer !== undefined ? footer : onOk ? undefined : null;
  return (
    <AntModal
      open={open}
      title={title}
      footer={resolvedFooter}
      okText={okText}
      cancelText={cancelText}
      onOk={onOk}
      onCancel={onClose}
      confirmLoading={confirmLoading}
      width={width}
      centered={centered}
      closable={closable}
      maskClosable={maskClosable}
      destroyOnClose
      className={className}
      style={style}
      data-testid={dataTestId}
    >
      {children}
    </AntModal>
  );
};
